/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import "react-circular-progressbar/dist/styles.css";
import { dashboardInfo } from "../../specs/dashboardInfo";
import { Card, Badge, Button, Spinner } from "react-bootstrap";
import "../../css/welcomeScreenAndPlanSectionCss.css";
import { useNavigate } from "react-router-dom";
// import { dummyData } from '../dummyData';
import axios from "axios";
// import { FetchPercentage } from '../FetchPercentage';
import { markNextCallsAsIgnored } from "../../lib/activityLogQueryParam";
import PlanDetailsSection from "../VizAppDashboardSections/PlanDetailsSection";
import { Box, LinearProgress, Typography, Stack, Skeleton } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PackageDetailSection from "./PackageDetailSection";
import ReportTypeSplitChart from "../DashboardSections/ReportTypeSplitChart";
import SmartReportAddonsTable from "./SmartReportAddonsTable";
import SmartReportRepeatRate from "./SmartReportRepeatRate";
import AiInsightsAndPlanSection from "./AiInsightsAndPlanSection";
import DashboardCarousel from "./DashboardCarousel";


const WelcomeScreenAndPlanSection = ({ productType, setProductType, navBarTriggered }) => {
  const navigate = useNavigate();
  // const currentMonthReportCounts = [];

  const [loginData, setLoginData] = useState("");
  const [clienInfo, setClienInfo] = useState("");
  const [reRenderComponent, setReRenderComponent] = useState(false);

  // Start as true so the skeleton always shows on first paint — prevents the fill
  // animation from firing prematurely at 0% before real data arrives.
  const [loader, setLoader] = useState(true);

  const [numberOfReportsConsumed, setNumberOfReportsConsumed] = useState(0);
  const [reportsSubscribed, setReportsSubscribed] = useState(1);
  // Key that increments whenever real count data arrives → forces fill Box to remount → animation replays
  const [fillAnimKey, setFillAnimKey] = useState(0);

  // Addons table stats — lifted from SmartReportAddonsTable via onStatsChange callback
  const [addonsStats, setAddonsStats] = useState({ total: null, startDate: '', endDate: '' });

  // Report Type chart stats — lifted from ReportTypeSplitChart via onStatsChange callback
  const [reportTypeStats, setReportTypeStats] = useState({ total: null, startDate: '', endDate: '' });

  // Repeat rate start date
  const [repeatRateStartDate, setRepeatRateStartDate] = useState(null);

  // Number of Reports Subscribed
  // const subscriptionOfReports = 750

  // const currentMonthReportsTotal = dummyData[0].current_month.day_wise

  // // calcuating current month report count
  // for (let x = 0; x < currentMonthReportsTotal.length; x++) {
  //     let currentMonthObj = currentMonthReportsTotal[x]
  //     for (let thisObj in currentMonthObj) {
  //         currentMonthReportCounts.push(currentMonthObj.count)
  //     }
  // }

  window.addEventListener("storage", (e) => {
    // console.log("something got changed.")
    setReRenderComponent(!reRenderComponent);
  });

  // console.log('numberOfReportsConsumed', numberOfReportsConsumed);
  // checking credentials
  useEffect(() => {
    const credentialsInfo = JSON.parse(localStorage.getItem("myLoginDetails"));
    const checkClientPreference = JSON.parse(
      localStorage.getItem("clientPreference")
    );

    let data = JSON.parse(localStorage.getItem("loginDetails"));
    setReportsSubscribed(data.reportsSubscribed);

    if (checkClientPreference) {
      setClienInfo(checkClientPreference);
    }

    if (credentialsInfo && data) {
      if (credentialsInfo === data.userId) {
        //console.log("login allowed.")
        navigate("/subscription");
        setLoginData(data);
      }
    } else {
      console.log("invalid login details.");
      navigate("/login");
    }
  }, [reRenderComponent]);

  useEffect(() => {
    // Show skeleton immediately on every product-type switch so the tube is
    // never painted at 0% before real data arrives (prevents stale animation).
    setLoader(true);
    setNumberOfReportsConsumed(0);
    localStorage.removeItem("reportsConsumedData");

    // Mark all API calls triggered by page-load / tab-switch as "auto" so they
    // get ignoreActivityLog=true and the backend doesn't count them as user activity.
    markNextCallsAsIgnored(5000);
  }, [productType]);

  useEffect(() => {
    // checking date
    // current date
    let todaysDate = new Date().toJSON().slice(0, 10).replace(/-/g, "/");

    let todaysDatePart1 = todaysDate.slice(0, 4);
    let todaysDatePart2 = todaysDate.slice(5, 7);
    let todaysDatePart3 = todaysDate.slice(8, 10);

    const getSavedDate = JSON.parse(localStorage.getItem("loggedOn"));

    let savedDatePart1 = getSavedDate ? getSavedDate.slice(0, 4) : "";
    let savedDatePart2 = getSavedDate ? getSavedDate.slice(5, 7) : "";
    let savedDatePart3 = getSavedDate ? getSavedDate.slice(8, 10) : "";

    let status1;
    let status2;
    let status3;

    console.log("part1", todaysDatePart1, savedDatePart1);
    console.log("part2", todaysDatePart2, savedDatePart2);
    console.log("part3", todaysDatePart3, savedDatePart3);

    let statusOfLoggedOn;

    if (todaysDatePart1 === savedDatePart1) {
      status1 = true;
    } else {
      status1 = false;
    }
    if (todaysDatePart2 === savedDatePart2) {
      console.log("");
      status2 = true;
    } else {
      status2 = false;
    }
    if (todaysDatePart3 === savedDatePart3) {
      status3 = true;
    } else {
      status3 = false;
    }

    console.log("statusOfLoggedOn", statusOfLoggedOn);

    if (status1 === true && status2 === true && status3 === true) {
      //
    } else {

      localStorage.setItem("myLoginDetails", JSON.stringify(""));
      localStorage.removeItem("loggedOn");
      localStorage.removeItem("loginDetails");
      localStorage.removeItem("homepageData");
      localStorage.setItem(
        "logoUrl",
        JSON.stringify(
          "https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg"
        )
      );
      window.dispatchEvent(new Event("storage"));
      window.location.reload();
    }

    const storedReportsCount = JSON.parse(
      localStorage.getItem("reportsConsumedData")
    );

    if (storedReportsCount) {
      setNumberOfReportsConsumed(parseInt(storedReportsCount));
      // Real data is available — bump key so the fill Box remounts and animates
      setFillAnimKey((k) => k + 1);
    } else {
      (async function () {
        await fetchReportCounts();
      })();
    }
  }, [productType]);

  const fetchReportCounts = async () => {
    setLoader(true);
    const endpointToCall = `https://api.niroggyan.com/billing/${productType}/counts?query_on=counts&query_by=subscription`;
    const idToken = localStorage.getItem("idTokenBilling");
    let config = {
      url: endpointToCall,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: idToken,
      },
      validateStatus: function (status) {
        return (status >= 200) & (status < 510);
      },
    };

    try {
      const axiosData = await axios(config);
      if (axiosData.data.isSuccess) {
        let reportCountData = axiosData.data.data[0];
        if (reportCountData) {
          setNumberOfReportsConsumed(parseInt(reportCountData.count));
          // Bump key so the fill Box remounts with the real usagePct and animates
          setFillAnimKey((k) => k + 1);
          localStorage.setItem(
            "reportsConsumedData",
            JSON.stringify(reportCountData.count)
          );
          setLoader(false);
        }
      }
    } catch (error) {
      console.log("Report count Error:\n", error);
    }
    setLoader(false);
  };

  // LOGOUT TIMER
  // useEffect(() => {
  //     if (counter < 1200) {
  //       setTimeout(() => {
  //         setCounter(counter + 1)
  //         // console.log("counter: ", counter)
  //       }, 1000)
  //     }

  //     if (counter === 1200) {
  //         alert("Session Expired loggin again!")
  //         localStorage.setItem("myLoginDetails", JSON.stringify(""))
  //         localStorage.removeItem("loginDetails")
  //         localStorage.removeItem("homepageData")
  //         localStorage.setItem("logoUrl", JSON.stringify("https://niroggyan.s3.ap-south-1.amazonaws.com/new-billing-dashboard-files/logos/niroggyan-logo.svg"))
  //         window.dispatchEvent(new Event("storage"));
  //         window.location.reload()
  //     }
  //   }, [counter])

  const resetToLIS = async () => {
    //console.log("LIS reset request")

    let orgName = loginData ? loginData.org : "";
    let centerName = loginData ? loginData.center : "";
    let lisName = loginData ? loginData.role : "";

    let homePageApiForLIS = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/home/?org=${orgName}&center=${centerName}&query_on=${lisName}`;

    var config = {
      method: "GET",
      // url: "",
      url: homePageApiForLIS,
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      // const axiosData = await axios(config);
      localStorage.removeItem("trialClientsData");
      localStorage.removeItem("trialClientPreference");
      // localStorage.setItem(
      //   'homepageData',
      //   JSON.stringify({ data: axiosData.data })
      // );
      localStorage.setItem("clientPreference", JSON.stringify("none"));
      localStorage.removeItem("orgPreference");
      setReRenderComponent(!reRenderComponent);
      window.dispatchEvent(new Event("storage"));
      window.location.reload();
    } catch (error) {
      console.log("LIS reset error: ", error);
    }
  };

  // PERCENTAGE CALCULATOR

  // const [numberOfReportsConsumed, setNumberOfReportsConsumed] = useState("0")
  // const [reportsSubscribedInfo, setReportsSubscribedInfo] = useState("0")

  // const [percentage, setPercentage] = useState("0")

  // useEffect(() => {
  //     //console.log("calling plan details section")
  //     const loginInfo = JSON.parse(localStorage.getItem("loginDetails"))
  //     let homepageData = JSON.parse(localStorage.getItem("homepageData"))
  //     let clientInfo = JSON.parse(localStorage.getItem("clientPreference"))

  //     if (loginInfo) {
  //         setReportsSubscribedInfo(loginInfo.reportsSubscribed)
  //         fetchReportCounts()
  //     }

  // }, [reRenderComponent])

  // const fetchReportCounts = async () => {
  //     let requiredData = JSON.parse(localStorage.getItem("loginDetails"))

  //     //console.log("fetching report counts....")
  //     // fetching reports consumed by client
  //     const endpointToCall = `https://rnxsohimg1.execute-api.ap-south-1.amazonaws.com/Production/clientdashboard/home/?org=${requiredData.org}&center=${requiredData.center}&startDate=${requiredData.startDate}&endDate=${requiredData.endDate}&query_on=${requiredData.role}`

  //     //console.log("this one: ", endpointToCall)

  //     let config = {
  //         url: endpointToCall,
  //         method: 'GET',
  //         headers: {
  //             'Content-Type': 'application/json'
  //         },
  //         //data: dataToSend,
  //     };

  //     //console.log("report count json:\n")
  //     //console.log(dataToSend)

  //     try {
  //         const axiosData = await axios(config)
  //         //console.log("inside axiosdata Report count  ===> \n\n", axiosData.data.subscription_data)
  //         let reportCountData = axiosData.data.subscription_data
  //         //localStorage.setItem("homepageData", JSON.stringify({ "data": axiosData.data }))
  //         // window.dispatchEvent(new Event("storage"));
  //         if (reportCountData) {
  //             setNumberOfReportsConsumed(parseInt(reportCountData.subscription_usage))
  //         }

  //     } catch (error) {
  //         console.log("Report count Error:\n", error)
  //     }
  // }

  // // calculate percentage
  // //    useEffect(() => {

  // // if (numberOfReportsConsumed !== 0) {
  // //     // set percentage
  // //     const thePercentage = Math.round((numberOfReportsConsumed / reportsSubscribedInfo : 0) * 100)

  // //     if (thePercentage > 100) {
  // //         setPercentage(100)
  // //     } else {
  // //         setPercentage(thePercentage)
  // //     }
  // // }

  // // }, [numberOfReportsConsumed, percentage])

  // // calculate percentage
  // useEffect(() => {

  //     const thePercentage = Math.round((numberOfReportsConsumed / reportsSubscribedInfo) * 100)
  //     // set percentage

  //     if (thePercentage > 100) {
  //         setPercentage(100)
  //     } else {
  //         setPercentage(thePercentage)
  //     }

  // }, [numberOfReportsConsumed, percentage])

  // console.log("the percentage: ", percentage)

  let colorCondition =
    loginData && loginData.subscriptionStatus === "on hold"
      ? "#ff4d4d"
      : "#27BC48";

  // return (
  //   <div className="mb-4">
  //     {/* Welcome Heading */}
  //     <div className="welcomeContentMargins">
  //       <span className="welcomeNoteCss">
  //         {/* {dashboardInfo.welcomeScreen.welcomeNote} */}
  //         {"Welcome"}
  //       </span>
  //       <span className="welcomeClientCss">
  //         {loginData ? loginData.displayName : ""}
  //       </span>
  //     </div>
  //     <Button
  //       className={"removeFocusCss badgeMarginCss"}
  //       style={{
  //         display: clienInfo && clienInfo === "none" ? "none" : "",
  //         cursor: "text",
  //         backgroundColor: "#3567d6",
  //         position: "relative",
  //       }}
  //     >
  //       {`Client ID: ${clienInfo}`}
  //       <Badge
  //         bg="info"
  //         title={"reset to default client"}
  //         onClick={resetToLIS}
  //         style={{
  //           width: "23px",
  //           height: "23px",
  //           cursor: "pointer",
  //           position: "absolute",
  //           top: "-10px",
  //           borderRadius: "100%",
  //         }}
  //       >
  //         <span style={{ position: "relative", top: "1px" }}>{"X"}</span>
  //       </Badge>
  //     </Button>
  //     {/* Welcome sreen and offering */}
  //     <div
  //       className="welcomeScreenResolutionCss"
  //       style={{ display: clienInfo && clienInfo === "none" ? "" : "none" }}
  //     >
  //       {/* Left Content */}

  //       <div className="welcomeScreenLeftContentCss">
  //         <Card className="" style={{ border: "none", position: "relative" }}>
  //           <Card.Img
  //             src="https://niroggyan.s3.ap-south-1.amazonaws.com/React-Billing-Dashboard-files/WelcomeScreen+Files/welcomeScreenSvg.svg"
  //             alt="Card image"
  //           />
  //           <Card.ImgOverlay className="offeringCardContentsCss">
  //             <Card.Title className="offeringHeadingCss">
  //               {"Offering Subscribed"}
  //             </Card.Title>
  //             <Card.Text className="offeringSubscribeForCss">
  //               {loginData ? loginData.subscription : ""}
  //             </Card.Text>
  //             <Card.Text>
  //               <button className="downloadBrochureButtonCss">
  //                 <a
  //                   style={{ textDecoration: "none", color: "inherit" }}
  //                   href={"https://brochure.niroggyan.com/"}
  //                   target={"_blank"}
  //                   rel="noreferrer"
  //                 >
  //                   <span className="downloadBrochureButtonContentCss"></span>
  //                   {/* {window.innerWidth < 600 ? dashboardInfo.welcomeScreen.brochureButtonInfoShort : dashboardInfo.welcomeScreen.brochureButtonInfo} */}

  //                   <svg
  //                     style={{ position: "relative", left: "5px", top: "-1px" }}
  //                     width="14"
  //                     height="10"
  //                     viewBox="0 0 14 10"
  //                     fill="none"
  //                     xmlns="http://www.w3.org/2000/svg"
  //                   >
  //                     <path
  //                       d="M12.4387 6.13439C12.7549 5.80831 12.9146 5.35828 12.9168 4.94832C12.919 4.53857 12.7641 4.08686 12.4515 3.75719L9.71512 0.873708C9.48049 0.62646 9.12686 0.624564 8.88962 0.869282C8.65235 1.114 8.65037 1.48267 8.885 1.7299L11.3477 4.32502L1.67683 4.27338C1.36244 4.2717 1.08572 4.5571 1.08396 4.88488C1.0822 5.21264 1.35583 5.501 1.67024 5.50269L11.3012 5.55433L8.81088 8.12289C8.57362 8.36761 8.57164 8.73628 8.80627 8.9835C9.0409 9.23073 9.39453 9.23265 9.63178 8.98793L12.4387 6.13439Z"
  //                       fill="white"
  //                       stroke="white"
  //                     />
  //                   </svg>
  //                 </a>
  //               </button>
  //             </Card.Text>

  //             {/* <div className="offeringCardItemsCss">

  //                               <div className="offeringHeadingCss">
  //                                   {dashboardInfo.welcomeScreen.offeringHeading}
  //                               </div>
  //                               <div className="offeringSubscribeForCss">
  //                                   {dashboardInfo.welcomeScreen.subscribedFor}
  //                               </div>

  //                               <button className="downloadBrochureButtonCss">
  //                                   {dashboardInfo.welcomeScreen.brochureButtonInfo}

  //                                   <svg style={{ marginLeft: "10px" }} width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  //                                       <path d="M20.9999 10.5135V14.8378C20.9999 16.0172 19.9753 17 18.7458 17H3.25411C2.02462 17 1 16.0172 1 14.8378V10.5135C1 10.1991 1.28688 9.92393 1.61466 9.92393C1.94245 9.92393 2.22932 10.1991 2.22932 10.5135V14.8378C2.22932 15.3882 2.68019 15.8207 3.25395 15.8207H18.7457C19.3194 15.8207 19.7703 15.3882 19.7703 14.8378V10.5135C19.7703 10.1991 20.0572 9.92393 20.385 9.92393C20.7132 9.92393 21 10.1599 21 10.5135H20.9999ZM9.81163 12.3613C10.1394 12.6757 10.5903 12.833 11.0002 12.833C11.41 12.833 11.8609 12.6757 12.1889 12.3613L15.0576 9.60954C15.3036 9.37358 15.3036 9.01995 15.0576 8.78402C14.8117 8.54807 14.443 8.54807 14.197 8.78402L11.6151 11.2606L11.6149 1.58959C11.6149 1.27519 11.328 1 11.0003 1C10.6725 1 10.3856 1.27518 10.3856 1.58959V11.2207L7.80371 8.74417C7.55773 8.50822 7.18905 8.50822 6.94309 8.74417C6.69712 8.98013 6.6971 9.33376 6.94309 9.56969L9.81163 12.3613Z" fill="white" stroke="white" />
  //                                   </svg>

  //                               </button>

  //                           </div> */}
  //           </Card.ImgOverlay>
  //         </Card>
  //       </div>

  //       {/* Right Content */}

  //       <div className="welcomeScreenRightContentCss">
  //         <span>
  //           <Card className="planCardCss">
  //             <Card.Body>
  //               <Card.Title>
  //                 {dashboardInfo.welcomeScreen.planInfo.planCardHeading}

  //                 {/* Plan Active Status Dot */}

  //                 <svg
  //                   style={{ float: "right", position: "relative", top: "5px" }}
  //                   width="18"
  //                   height="18"
  //                   viewBox="0 0 18 18"
  //                   fill="none"
  //                   xmlns="http://www.w3.org/2000/svg"
  //                 >
  //                   <circle
  //                     cx="9"
  //                     cy="9"
  //                     r="8"
  //                     stroke={colorCondition}
  //                     stroke-width="1.38462"
  //                   />
  //                   <circle
  //                     cx="9.15385"
  //                     cy="9.15385"
  //                     r="6.15385"
  //                     fill={colorCondition}
  //                   />
  //                 </svg>
  //               </Card.Title>

  //               <Card.Subtitle className="text-muted">
  //                 <div className="planCardSubtitleCss">
  //                   <span className="planPlaceholderCss">
  //                     {/* here */}
  //                     {dashboardInfo.welcomeScreen.planInfo.planPlaceHolder}
  //                   </span>
  //                   <span
  //                     className="planActiveStatusCss"
  //                     style={{
  //                       color: "#fff",
  //                       backgroundColor: colorCondition,
  //                     }}
  //                   >
  //                     {loginData && loginData.subscriptionStatus
  //                       ? loginData.subscriptionStatus.toUpperCase()
  //                       : "None"}
  //                     {/* {} */}
  //                   </span>
  //                 </div>
  //               </Card.Subtitle>

  //               <Card.Subtitle
  //                 className="text-muted subscriptionWarningCss"
  //                 style={{
  //                   display:
  //                     Math.round(
  //                       (numberOfReportsConsumed / reportsSubscribed) * 100
  //                     ) > 80 &&
  //                     loginData &&
  //                     loginData.role === "lab"
  //                       ? ""
  //                       : "none",
  //                 }}
  //               >
  //                 <div
  //                   style={{
  //                     width: "100%",
  //                     display: "flex",
  //                   }}
  //                 >
  //                   <div
  //                     style={{
  //                       width: "50px",
  //                     }}
  //                   >
  //                     <i
  //                       class="fa fa-exclamation-triangle text-warning fa-2x"
  //                       aria-hidden="true"
  //                     ></i>
  //                   </div>
  //                   <div
  //                     className="col"
  //                     style={{
  //                       width: "100%",
  //                     }}
  //                   >
  //                     <span className="subscriptionWarningTextCss">
  //                       <span>{"you have used"} </span>{" "}
  //                       <span style={{ fontWeight: "bold", color: "black" }}>
  //                         {/* {FetchPercentage()} */}
  //                         {Math.round(
  //                           (numberOfReportsConsumed / reportsSubscribed) * 100
  //                         )}
  //                         {"%"}
  //                       </span>{" "}
  //                       <span>
  //                         {
  //                           " of your usage plan, please contact the business team for an extention"
  //                         }
  //                       </span>
  //                     </span>
  //                   </div>
  //                 </div>
  //               </Card.Subtitle>

  //               <Card.Text
  //                 className="text-muted planMoreInfoCss"
  //                 style={{
  //                   display:
  //                     (loginData &&
  //                       loginData.role === "LIS" &&
  //                       loginData.showBilling === true) ||
  //                     (loginData && loginData.role === "lab")
  //                       ? ""
  //                       : "none",
  //                 }}
  //               >
  //                 <div className="startDateCss">
  //                   <span style={{ color: "#7787bc" }}>{"Start Date: "}</span>
  //                   <span style={{ fontWeight: "550" }}>
  //                     {loginData
  //                       ? loginData.startDate
  //                           .split(" ")[0]
  //                           .split("-")
  //                           .reverse()
  //                           .join("-")
  //                       : ""}
  //                   </span>
  //                 </div>
  //                 <div className="endDateCss">
  //                   <span style={{ color: "#7787bc" }}>{"End Date: "}</span>
  //                   <span style={{ fontWeight: "550" }}>
  //                     {loginData
  //                       ? loginData.endDate
  //                           .split(" ")[0]
  //                           .split("-")
  //                           .reverse()
  //                           .join("-")
  //                       : ""}
  //                   </span>
  //                 </div>
  //               </Card.Text>

  //               {/* For LIS (below condition) */}

  //               <Card.Text
  //                 className="text-muted planMoreInfoCss"
  //                 style={{
  //                   display:
  //                     loginData &&
  //                     loginData.role === "LIS" &&
  //                     loginData.showBilling !== true
  //                       ? ""
  //                       : "none",
  //                 }}
  //               >
  //                 <div>
  //                   <span style={{ color: "#7787bc" }}>{"LIS"}</span>
  //                 </div>
  //               </Card.Text>

  //               {/* For ADMIN (below condition) */}

  //               <Card.Text
  //                 className="text-muted planMoreInfoCss"
  //                 style={{
  //                   display:
  //                     loginData && loginData.role === "admin" ? "" : "none",
  //                 }}
  //               >
  //                 <div>
  //                   <span style={{ color: "#7787bc" }}>{"Admin"}</span>
  //                 </div>
  //               </Card.Text>
  //             </Card.Body>
  //           </Card>
  //         </span>
  //       </div>
  //     </div>
  //     {loader ? (
  //       <Spinner
  //         className="spinner-border"
  //         style={{ fontWeight: "normal" }}
  //         id="loadingSpinnerCss"
  //         animation="border"
  //         role="status"
  //       />
  //     ) : (
  //       <PlanDetailsSection reportsConsumed={numberOfReportsConsumed} />
  //     )}
  //   </div>
  // );

  const modifySubscriptionData = () => {
    const reportType = {
      advanced: "Total",
      advance: "Total",
      dynamic: "Personal",
      compact: "Compact",
    };
    if (!loginData?.subscription) {
      return "";
    }

    let subscriptionData = loginData?.subscription
      ?.split("+")
      .map((each) => each.trim());

    subscriptionData.splice(
      0,
      1,
      reportType[subscriptionData[0].trim().toLowerCase()]
    );
    return subscriptionData.join(`${" "}+${" "}`);
  };

  const getParsedEndDate = () => {
    const rawDate = loginData?.endDate?.split(" ")[0];
    if (!rawDate) {
      return null;
    }

    const parts = rawDate.split("-");
    if (parts.length === 3) {
      if (parts[0].length === 4) {
        const parsed = new Date(`${parts[0]}-${parts[1]}-${parts[2]}T00:00:00`);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
      if (parts[2].length === 4) {
        const parsed = new Date(`${parts[2]}-${parts[1]}-${parts[0]}T00:00:00`);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
    }

    const fallback = new Date(rawDate);
    return Number.isNaN(fallback.getTime()) ? null : fallback;
  };

  const parsedEndDate = getParsedEndDate();
  const remainingDays = parsedEndDate
    ? Math.max(0, Math.ceil((parsedEndDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)))
    : null;

  const usagePct =
    reportsSubscribed && reportsSubscribed > 0
      ? Math.min(Math.round((numberOfReportsConsumed / reportsSubscribed) * 100), 100)
      : 0;
  const remaining = Math.max(0, (reportsSubscribed || 0) - numberOfReportsConsumed);

  const parsedStartDate = (() => {
    const raw = loginData?.startDate?.split(" ")[0];
    if (!raw) return null;
    const parts = raw.split("-");
    if (parts.length === 3) {
      if (parts[0].length === 4) return new Date(`${parts[0]}-${parts[1]}-${parts[2]}T00:00:00`);
      if (parts[2].length === 4) return new Date(`${parts[2]}-${parts[1]}-${parts[0]}T00:00:00`);
    }
    const fb = new Date(raw);
    return Number.isNaN(fb.getTime()) ? null : fb;
  })();

  const totalSubDays = parsedStartDate && parsedEndDate
    ? Math.max(1, Math.ceil((parsedEndDate.getTime() - parsedStartDate.getTime()) / (1000 * 60 * 60 * 24)))
    : null;

  const daysElapsed = parsedStartDate
    ? Math.max(1, Math.ceil((new Date().getTime() - parsedStartDate.getTime()) / (1000 * 60 * 60 * 24)))
    : null;

  const timePct = totalSubDays && daysElapsed !== null
    ? Math.min(Math.round((daysElapsed / totalSubDays) * 100), 100)
    : null;

  // Compute dailyAvg using the same period data (and same formula) that MetricsSection uses
  // so both places show an identical value.
  // MetricsSection stores its fetched data in localStorage as currentMonthReportData /
  // currentWeekReportData (array of {date, count}).  We re-derive the average from that.
  const dailyAvg = (() => {
    try {
      const raw =
        localStorage.getItem("currentMonthReportData") ||
        localStorage.getItem("currentWeekReportData");
      if (raw) {
        const rows = JSON.parse(raw);
        if (Array.isArray(rows) && rows.length > 0) {
          const total = rows.reduce((s, d) => s + parseInt(d.count || 0, 10), 0);
          return total > 0 ? Math.round(total / rows.length) : null;
        }
      }
    } catch (_) { /* ignore parse errors */ }
    // Fallback: subscription-period average
    return daysElapsed && daysElapsed > 0 && numberOfReportsConsumed > 0
      ? Math.round(numberOfReportsConsumed / daysElapsed)
      : null;
  })();

  return (
    <Stack
      direction="column"
      gap={3}
      // sx={{ background: "#1976d2", borderRadius: "16px" }}
      sx={{ width: "100%" }}
    >
      {/* KPI Hero Strip */}
      {loginData && loginData.role !== "admin" && (
        <Box
          sx={{
            background: "linear-gradient(135deg, #3567D6 0%, #170C6B 100%)",
            borderRadius: "16px",
            p: { xs: "14px 14px", md: "16px 20px" },
            color: "#fff",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative blobs */}
          <Box sx={{ position: "absolute", top: -40, right: -40, width: 160, height: 160, borderRadius: "50%", background: "rgba(60,208,255,0.08)", pointerEvents: "none" }} />
          <Box sx={{ position: "absolute", bottom: -30, right: 80, width: 100, height: 100, borderRadius: "50%", background: "rgba(255,255,255,0.04)", pointerEvents: "none" }} />

          <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems={{ md: "center" }} gap={{ xs: 1.25, md: 1.75 }}>
            {/* Left: Lab identity — redesigned */}
            <Stack direction="row" alignItems="center" gap={1.75} sx={{ flexGrow: 1 }}>
              {/* Circular logo / avatar */}
              <Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: "50%",
                  background: "#fff",
                  flexShrink: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.18)",
                }}
              >
                {loginData?.logoSrc ? (
                  <Box
                    component="img"
                    src={loginData.logoSrc}
                    alt={loginData.center}
                    sx={{ width: "100%", height: "100%", objectFit: "contain", p: "6px" }}
                  />
                ) : (
                  <BusinessCenterOutlinedIcon sx={{ fontSize: 26, color: "#3567D6" }} />
                )}
              </Box>

              {/* Text block */}
              <Stack gap={0.35}>
                {/* Welcome heading + LIVE badge */}
                <Stack direction="row" alignItems="center" gap={1}>
                  <Typography
                    sx={{
                      fontSize: { xs: "15px", md: "18px" },
                      fontWeight: 800,
                      color: "#fff",
                      lineHeight: 1.2,
                      letterSpacing: "-0.2px",
                    }}
                  >
                    Welcome back,{" "}
                    {loginData?.displayName === "Dummy User"
                      ? "Your Lab"
                      : (loginData?.customerName || loginData?.displayName || "User")}
                  </Typography>
                  {/* LIVE badge */}
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "4px",
                      background: "rgba(167,255,192,0.15)",
                      border: "1px solid rgba(167,255,192,0.35)",
                      borderRadius: "999px",
                      px: "8px",
                      py: "2px",
                    }}
                  >
                    <Box
                      sx={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: loginData?.subscriptionStatus === "on hold" ? "#FFCBCB" : "#A7FFC0",
                        animation: "pulse 1.8s ease-in-out infinite",
                        "@keyframes pulse": {
                          "0%, 100%": { opacity: 1 },
                          "50%": { opacity: 0.3 },
                        },
                      }}
                    />
                    <Typography
                      sx={{ fontSize: "10px", fontWeight: 700, color: loginData?.subscriptionStatus === "on hold" ? "#FFCBCB" : "#A7FFC0", letterSpacing: "0.5px" }}
                    >
                      {loginData?.subscriptionStatus === "on hold" ? "ON HOLD" : "LIVE"}
                    </Typography>
                  </Box>
                </Stack>

                {/* Subtitle */}
                <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.68)", lineHeight: 1.4 }}>
                  Here's what's happening with your health platform today
                </Typography>

                {/* Plan active pill */}
                <Box
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    mt: 0.5,
                    background: "rgba(255,255,255,0.08)",
                    border: "1px solid rgba(255,255,255,0.16)",
                    borderRadius: "999px",
                    px: 1.25,
                    py: 0.4,
                    width: "fit-content",
                  }}
                >
                  <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.82)", fontWeight: 600 }}>
                    {modifySubscriptionData() || "Plan Active"}
                  </Typography>
                </Box>
              </Stack>
            </Stack>

            {/* Right: KPI tiles */}
            <Stack direction="row" gap={1.25} sx={{ flexWrap: { xs: "nowrap", sm: "nowrap" }, overflowX: "auto", pb: { xs: 1, md: 0 } }}>
              {/* Reports Used */}
              {loginData?.showBilling === true && (
                <Box
                  sx={{
                    background: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(8px)",
                    borderRadius: "10px",
                    border: "1px solid rgba(255,255,255,0.15)",
                    p: "10px 12px",
                    minWidth: { xs: 150, sm: 150 },
                    flex: 1,
                  }}
                >
                  <Stack direction="row" alignItems="center" gap={0.75} mb={0.75}>
                    <AssessmentOutlinedIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.7)" }} />
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      Reports Used
                    </Typography>
                  </Stack>
                  {loader ? (
                    <>
                      <Skeleton variant="text" width="70%" height={34} sx={{ bgcolor: "rgba(255,255,255,0.25)", transform: "none", borderRadius: "6px" }} />
                      <Skeleton variant="rounded" width="100%" height={6} sx={{ bgcolor: "rgba(255,255,255,0.2)", mt: 0.75, borderRadius: "4px" }} />
                      <Skeleton variant="text" width="45%" height={16} sx={{ bgcolor: "rgba(255,255,255,0.2)", mt: 0.75, transform: "none", borderRadius: "6px" }} />
                    </>
                  ) : (
                    <>
                      <Stack direction="row" alignItems="baseline" gap={0.6} mb={0.9}>
                        <Typography sx={{ fontSize: "22px", fontWeight: 800, color: "#fff", lineHeight: 1 }}>
                          {numberOfReportsConsumed.toLocaleString()}
                        </Typography>
                        <Typography sx={{ fontSize: "12px", color: "rgba(255,255,255,0.55)" }}>
                          / {loginData?.reportsSubscribed?.toLocaleString() || "—"}
                        </Typography>
                      </Stack>
                      <LinearProgress
                        variant="determinate"
                        value={
                          loginData?.reportsSubscribed
                            ? Math.min(Math.round((numberOfReportsConsumed / loginData.reportsSubscribed) * 100), 100)
                            : 0
                        }
                        sx={{
                          height: 5,
                          borderRadius: 4,
                          backgroundColor: "rgba(255,255,255,0.2)",
                          "& .MuiLinearProgress-bar": {
                            background: "linear-gradient(90deg, #3CD0FF, #22C55E)",
                            borderRadius: 4,
                          },
                        }}
                      />
                      <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.5)", mt: 0.6 }}>
                        {loginData?.reportsSubscribed
                          ? `${Math.min(Math.round((numberOfReportsConsumed / loginData.reportsSubscribed) * 100), 100)}% utilized`
                          : "N/A"}
                      </Typography>
                    </>
                  )}
                </Box>
              )}

              {/* Active Plan */}
              {loginData?.showBilling === true && (
                <Box
                  sx={{
                    background: "rgba(255,255,255,0.1)",
                    backdropFilter: "blur(8px)",
                    borderRadius: "10px",
                    border: "1px solid rgba(255,255,255,0.15)",
                    p: "10px 12px",
                    minWidth: { xs: 140, sm: 140 },
                    flex: 1,
                  }}
                >
                  <Stack direction="row" alignItems="center" gap={0.75} mb={0.75}>
                    <VerifiedOutlinedIcon sx={{ fontSize: 16, color: "rgba(255,255,255,0.7)" }} />
                    <Typography sx={{ fontSize: "10px", fontWeight: 700, color: "rgba(255,255,255,0.7)", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      Active Plan
                    </Typography>
                  </Stack>
                  {loader ? (
                    <>
                      <Skeleton variant="text" width="72%" height={30} sx={{ bgcolor: "rgba(255,255,255,0.25)", transform: "none", borderRadius: "6px" }} />
                      <Skeleton variant="text" width="58%" height={16} sx={{ bgcolor: "rgba(255,255,255,0.2)", mt: 0.5, transform: "none", borderRadius: "6px" }} />
                    </>
                  ) : (
                    <>
                      <Typography sx={{ fontSize: "16px", fontWeight: 800, color: "#fff", mb: 0.3, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                        {loginData?.planName || loginData?.subscription || "Starter Plan"}
                      </Typography>
                      <Stack direction="row" alignItems="center" gap={0.75}>
                        <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: "#22C55E", flexShrink: 0 }} />
                        <Typography sx={{ fontSize: "10.5px", color: "rgba(255,255,255,0.55)" }}>
                          Until {loginData?.endDate ? loginData.endDate.split(" ")[0].split("-").reverse().join("-") : "N/A"}
                        </Typography>
                      </Stack>
                      <Box sx={{ borderTop: "1px solid rgba(255,255,255,0.16)", mt: 0.9, pt: 0.8 }}>
                        <Stack direction="row" alignItems="center" justifyContent="space-between">
                          <Typography sx={{ fontSize: "10px", color: "rgba(255,255,255,0.56)", textTransform: "uppercase", letterSpacing: "0.4px" }}>
                            Remaining Days
                          </Typography>
                          <Typography sx={{ fontSize: "11px", color: "#fff", fontWeight: 700, maxWidth: 96, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            {remainingDays !== null ? `${remainingDays} days` : "N/A"}
                          </Typography>
                        </Stack>
                      </Box>
                    </>
                  )}
                </Box>
              )}
            </Stack>
          </Stack>
        </Box>
      )}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ width: "100%", display: "none" }}
      >
        <Typography variant="h1">Overview</Typography>
        {loginData && loginData.role === "lab" ? (
          <Stack direction="row" gap={3} alignItems="center">
            {/* <Box
              sx={{
                padding: "10px 14px",
                background: "#fff",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              <NotificationsIcon />
            </Box> */}
            <Box
              sx={{
                padding: "10px 14px",
                background: "#fff",
                borderRadius: "8px",
                textAlign: "center",
              }}
            >
              {loginData && loginData.role === "lab" ? (
                <div>
                  <img
                    src={loginData.logoSrc}
                    alt={loginData.center}
                    height="50px"
                    width="150px"
                    style={{ objectFit: "contain", display: "none" }}
                  />
                  <Typography
                    sx={{
                      height: "50px",
                      width: "150px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Your logo
                  </Typography>
                </div>
              ) : (
                ""
              )}
            </Box>
          </Stack>
        ) : (
          ""
        )}
      </Stack>

      {/* Product Selector — Styled Tabs */}
      <Stack direction="row" gap={1.5} alignItems="center" mt={0.5} mb={2.5} flexWrap={{ xs: "nowrap", md: "wrap" }} sx={{ overflowX: "auto", pb: { xs: 0.5, md: 0 } }}>
        {[
          { value: "smartreport", label: "Smart Report" },
          { value: "vizapp", label: "Viz App" },
          { value: "videoreport", label: "Smart Video Report" },
        ].map((product) => (
          <Box
            key={product.value}
            onClick={() => {
              if (product.value === "smartreport" && productType !== "smartreport") {
                // Switching from Viz App / Video Report → Smart Report.
                // Clear all data-cache keys so every API is hit fresh.
                localStorage.removeItem("reportsConsumedData");
                localStorage.removeItem("currentMonthReportData");
                localStorage.removeItem("currentWeekReportData");
                localStorage.removeItem("prevMonthReportData");
              }
              if (setProductType) setProductType(product.value);
            }}
            sx={{
              px: "16px",
              py: "8px",
              borderRadius: "24px",
              cursor: "pointer",
              fontSize: "13px",
              fontFamily: "IBM Plex Sans, sans-serif",
              fontWeight: productType === product.value ? 700 : 500,
              color: productType === product.value ? "#fff" : "#3567D6",
              background:
                productType === product.value
                  ? "linear-gradient(135deg, #3567D6, #170C6B)"
                  : "#fbfbfe",
              border:
                productType === product.value
                  ? "none"
                  : "1px solid #D0DEFF",
              boxShadow:
                productType === product.value
                  ? "0 4px 14px rgba(53,103,214,0.35)"
                  : "none",
              transition: "all 0.2s ease",
              userSelect: "none",
              whiteSpace: "nowrap",
            }}
          >
            {product.label}
          </Box>
        ))}
      </Stack>

      {loginData?.displayName !== "Dummy User" && (
        <AiInsightsAndPlanSection
          productType={productType}
          usagePct={usagePct}
        />
      )}


      {/* Subscription Usage — Glass Test Tube Card */}
      {loginData && loginData.role !== "admin" && loginData?.showBilling === true && (
        <Box
          sx={{
            background: "#fff",
            borderRadius: "16px",
            p: { xs: "16px", md: "20px 24px" },
            boxShadow: "0 2px 16px rgba(53,103,214,0.08)",
          }}
        >
          {/* Header */}
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={2.5}>
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: "15px", color: "#170C6B", mb: 0.3 }}>
                Subscription Usage
              </Typography>
              <Typography sx={{ fontSize: "11.5px", color: "#9DA3AE" }}>
                Monthly report consumption
              </Typography>
            </Box>
            <Box
              sx={{
                background: "linear-gradient(135deg, #EEF2FF 0%, #E0E8FF 100%)",
                borderRadius: "10px",
                px: 1.5,
                py: 0.75,
              }}
            >
              <Typography sx={{ fontSize: "13px", fontWeight: 800, color: "#3567D6" }}>
                {usagePct}% Used
              </Typography>
            </Box>
          </Stack>

          {loader ? (
            <Stack direction={{ xs: "column", md: "row" }} gap={2.5} alignItems={{ xs: "center", md: "flex-start" }} sx={{ width: "100%" }}>
              <Skeleton variant="rounded" width={64} height={280} sx={{ borderRadius: "8px 8px 32px 32px", flexShrink: 0 }} />
              <Stack gap={1.5} sx={{ flex: 1, width: "100%" }}>
                <Stack direction="row" gap={1.5}>
                  {[1, 2, 3].map((i) => (
                    <Skeleton key={i} variant="rounded" height={130} sx={{ flex: 1, borderRadius: "14px" }} />
                  ))}
                </Stack>
                <Skeleton variant="rounded" height={76} sx={{ borderRadius: "14px" }} />
              </Stack>
            </Stack>
          ) : (
            <Stack direction={{ xs: "column", md: "row" }} gap={3} alignItems={{ xs: "center", md: "flex-start" }} sx={{ width: "100%" }}>
              {/* ── LEFT: Glass Test Tube ── */}
              <Stack alignItems="center" gap={1.25} sx={{ flexShrink: 0 }}>
                <Box
                  sx={{
                    width: 64,
                    height: 216,
                    borderRadius: "8px 8px 32px 32px",
                    border: "2.5px solid rgba(53,103,214,0.18)",
                    background: "linear-gradient(to right, rgba(255,255,255,0.95) 0%, rgba(225,235,255,0.55) 50%, rgba(225,235,255,0.65) 100%)",
                    position: "relative",
                    overflow: "hidden",
                    boxShadow: "inset 0 2px 12px rgba(53,103,214,0.07), 0 8px 28px rgba(53,103,214,0.13)",
                  }}
                >
                  {/* Liquid fill — animation name includes fillAnimKey so Emotion generates
                      a brand-new @keyframes rule the browser has never seen before —
                      the fill animation is guaranteed to replay from 0% every time */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      height: `${usagePct}%`,
                      background: "linear-gradient(to top, #1a3fa3 0%, #3567D6 52%, #5294FF 100%)",
                      [`@keyframes fillOnce_${fillAnimKey}`]: {
                        "0%":   { height: "0%", opacity: 0.7 },
                        "75%":  { height: `${Math.min(usagePct + 2, 100)}%`, opacity: 1 },
                        "88%":  { height: `${Math.max(usagePct - 1, 0)}%` },
                        "100%": { height: `${usagePct}%` },
                      },
                      animation: `fillOnce_${fillAnimKey} 2s cubic-bezier(0.22, 1, 0.36, 1) forwards`,
                    }}
                  >
                    {/* Meniscus wave */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: "-15%",
                        right: "-15%",
                        height: 20,
                        background: "rgba(255,255,255,0.22)",
                        borderRadius: "50%",
                        transform: "translateY(-50%)",
                        "@keyframes wave": {
                          "0%":   { transform: "translateY(-50%) scaleX(1) translateX(0%)" },
                          "30%":  { transform: "translateY(-56%) scaleX(1.1) translateX(2%)" },
                          "60%":  { transform: "translateY(-44%) scaleX(0.95) translateX(-2%)" },
                          "100%": { transform: "translateY(-50%) scaleX(1) translateX(0%)" },
                        },
                        animation: "wave 3s ease-in-out 2s infinite",
                      }}
                    />
                    {/* Shimmer */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: "18%",
                        right: "18%",
                        height: 4,
                        background: "rgba(255,255,255,0.3)",
                        borderRadius: "999px",
                        "@keyframes shimmer": {
                          "0%, 100%": { opacity: 0.3 },
                          "50%": { opacity: 0.7 },
                        },
                        animation: "shimmer 2.8s ease-in-out 2s infinite",
                      }}
                    />
                  </Box>
                  {/* Glass sheen — primary */}
                  <Box sx={{ position: "absolute", top: 12, left: 9, width: 7, height: "50%", background: "rgba(255,255,255,0.72)", borderRadius: "4px", zIndex: 3, pointerEvents: "none" }} />
                  {/* Glass sheen — secondary */}
                  <Box sx={{ position: "absolute", top: 18, left: 20, width: 4, height: "26%", background: "rgba(255,255,255,0.42)", borderRadius: "4px", zIndex: 3, pointerEvents: "none" }} />
                  {/* Tick marks */}
                  {[25, 50, 75].map((tick) => (
                    <Box key={tick} sx={{ position: "absolute", right: 0, bottom: `${tick}%`, width: 10, height: "1.5px", background: "rgba(53,103,214,0.22)", zIndex: 3 }} />
                  ))}
                </Box>
                <Typography sx={{ fontWeight: 800, fontSize: "20px", color: "#3567D6", lineHeight: 1 }}>
                  {usagePct}%
                </Typography>
                <Typography sx={{ fontSize: "14.5px", fontWeight: 'bold', color: "#8d8d8dff", mt: -0.25, letterSpacing: "0.3px" }}>
                  Used
                </Typography>
              </Stack>

              {/* ── RIGHT: Bento grid ── */}
              <Stack gap={1.5} sx={{ flex: 1, width: { xs: "100%", md: "auto" } }}>
                {/* Row 1: 3 stat cards — order: Total Limit → Reports Used → Remaining */}
                <Stack direction="row" gap={1.5} sx={{ overflowX: "auto", pb: { xs: 1, md: 0 }, width: "100%" }}>
                  {/* Card 1: Total Limit */}
                  <Box
                    sx={{
                      background: "#F7F9FF",
                      borderRadius: "12px",
                      p: "11px",
                      flex: 1,
                      minWidth: { xs: 130, md: "auto" },
                      border: "1px solid #EBF0FF",
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                    }}
                  >
                    <Box sx={{ background: "#EEF2FF", borderRadius: "8px", p: "5px", width: "fit-content", mb: 0.25 }}>
                      <BusinessCenterOutlinedIcon sx={{ fontSize: 15, color: "#8B9EC7", display: "block" }} />
                    </Box>
                    <Typography sx={{ fontSize: "9px", color: "#9DA3AE", textTransform: "uppercase", letterSpacing: "0.6px", fontWeight: 700 }}>
                      Total Limit
                    </Typography>
                    <Typography sx={{ fontSize: "18px", fontWeight: 800, color: "#4B5882", lineHeight: 1.1 }}>
                      {reportsSubscribed ? Number(reportsSubscribed).toLocaleString("en-IN") : "—"}
                    </Typography>
                    <Box
                      sx={{
                        display: "inline-flex",
                        background: "#E8EEFF",
                        borderRadius: "5px",
                        px: 0.8,
                        py: 0.25,
                        width: "fit-content",
                        mt: 0.1,
                      }}
                    >
                      <Typography sx={{ fontSize: "9px", color: "#3567D6", fontWeight: 700, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 90 }}>
                        {modifySubscriptionData() || loginData?.planName || "Active Plan"}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Card 2: Reports Used */}
                  <Box
                    sx={{
                      background: "linear-gradient(145deg, #EEF3FF 0%, #E2ECFF 100%)",
                      borderRadius: "12px",
                      p: "11px",
                      flex: 1,
                      minWidth: { xs: 130, md: "auto" },
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                    }}
                  >
                    <Box sx={{ background: "rgba(53,103,214,0.12)", borderRadius: "8px", p: "5px", width: "fit-content", mb: 0.25 }}>
                      <AssessmentOutlinedIcon sx={{ fontSize: 15, color: "#3567D6", display: "block" }} />
                    </Box>
                    <Typography sx={{ fontSize: "9px", color: "#8894B4", textTransform: "uppercase", letterSpacing: "0.6px", fontWeight: 700 }}>
                      Reports Used
                    </Typography>
                    <Typography sx={{ fontSize: "18px", fontWeight: 800, color: "#3567D6", lineHeight: 1.1 }}>
                      {numberOfReportsConsumed.toLocaleString("en-IN")}
                    </Typography>
                  </Box>

                  {/* Card 3: Remaining */}
                  <Box
                    sx={{
                      background: "linear-gradient(145deg, #EDFAF4 0%, #D9F5E7 100%)",
                      borderRadius: "12px",
                      p: "11px",
                      flex: 1,
                      minWidth: { xs: 130, md: "auto" },
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                    }}
                  >
                    <Box sx={{ background: "rgba(34,197,94,0.14)", borderRadius: "8px", p: "5px", width: "fit-content", mb: 0.25 }}>
                      <VerifiedOutlinedIcon sx={{ fontSize: 15, color: "#22C55E", display: "block" }} />
                    </Box>
                    <Typography sx={{ fontSize: "9px", color: "#6AAF8A", textTransform: "uppercase", letterSpacing: "0.6px", fontWeight: 700 }}>
                      Remaining
                    </Typography>
                    <Typography sx={{ fontSize: "18px", fontWeight: 800, color: "#15803D", lineHeight: 1.1 }}>
                      {remaining.toLocaleString("en-IN")}
                    </Typography>
                  </Box>
                </Stack>

                {/* Row 2: Plan Period — 78% of bento ≈ 70% of full card */}
                {(() => {
                  const paceGap = (usagePct ?? 0) - (timePct ?? 0);
                  const paceLabel = paceGap > 12 ? "Ahead of pace" : paceGap < -12 ? "Under pace" : "On track";
                  const paceColor = paceGap > 12 ? "#d97706" : paceGap < -12 ? "#16a34a" : "#3567D6";
                  const paceBg   = paceGap > 12 ? "#fffbeb" : paceGap < -12 ? "#f0fdf4" : "#eff6ff";
                  const usageBarColor = usagePct >= 85 ? "#EF4444" : usagePct >= 60 ? "#d97706" : "#16a34a";
                  const daysColor = remainingDays !== null && remainingDays < 30 ? "#EF4444" : "#3567D6";
                  return (
                    <Box sx={{ width: { xs: "100%", md: "78%" }, mx: "auto", display: { xs: "none", md: "block" }, mt: 1.5, overflowX: "auto", pb: { xs: 1, md: 0 } }}>
                      <Box sx={{ background: "linear-gradient(135deg, #F8FAFF 0%, #EEF3FF 100%)", borderRadius: "14px", p: "14px 18px", border: "1px solid #E8EEF8", minWidth: { xs: 320, md: "auto" } }}>
                        <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1.5}>
                          <Stack direction="row" alignItems="center" gap={0.6}>
                            <CalendarMonthOutlinedIcon sx={{ fontSize: 12, color: "#3567D6" }} />
                            <Typography sx={{ fontSize: "9px", color: "#9DA3AE", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: 700 }}>Plan Period</Typography>
                          </Stack>
                          <Box sx={{ background: paceBg, border: `1px solid ${paceColor}30`, borderRadius: "6px", px: "7px", py: "2px" }}>
                            <Typography sx={{ fontSize: "9px", fontWeight: 700, color: paceColor }}>{paceLabel}</Typography>
                          </Box>
                        </Stack>
                        <Stack direction="row" alignItems="flex-start" gap={2}>
                          <Box sx={{ flexShrink: 0, minWidth: 70 }}>
                            <Typography sx={{ fontSize: "10.5px", fontWeight: 700, color: "#170C6B" }}>{loginData?.startDate ? loginData.startDate.split(" ")[0].split("-").reverse().join("/") : "—"}</Typography>
                            <Typography sx={{ fontSize: "9.5px", color: "#C4CBD8", my: 0.2 }}>to</Typography>
                            <Typography sx={{ fontSize: "10.5px", fontWeight: 700, color: "#170C6B" }}>{loginData?.endDate ? loginData.endDate.split(" ")[0].split("-").reverse().join("/") : "—"}</Typography>
                          </Box>
                          <Box sx={{ flex: 1 }}>
                            <Stack direction="row" alignItems="center" gap={1} mb={1}>
                              <Typography sx={{ fontSize: "9px", color: "#9DA3AE", fontWeight: 600, minWidth: 66, textTransform: "uppercase", letterSpacing: "0.4px" }}>Time</Typography>
                              <Box sx={{ flex: 1, height: 9, borderRadius: "999px", background: "rgba(53,103,214,0.1)", position: "relative" }}>
                                <Box sx={{ position: "absolute", top: 0, left: 0, height: "100%", width: `${timePct ?? 0}%`, background: "linear-gradient(90deg, #3567D6 0%, #5294FF 100%)", borderRadius: "999px", [`@keyframes tF_${fillAnimKey}`]: { "0%": { width: "0%" }, "100%": { width: `${timePct ?? 0}%` } }, animation: `tF_${fillAnimKey} 1.8s ease-out forwards` }} />
                                <Box sx={{ position: "absolute", top: "50%", left: `${timePct ?? 0}%`, transform: "translate(-50%,-50%)", zIndex: 2 }}>
                                  <Box sx={{ position: "absolute", width: 20, height: 20, borderRadius: "50%", background: "rgba(53,103,214,0.18)", top: "50%", left: "50%", transform: "translate(-50%,-50%)", "@keyframes pulse": { "0%": { transform: "translate(-50%,-50%) scale(0.8)", opacity: 1 }, "100%": { transform: "translate(-50%,-50%) scale(2)", opacity: 0 } }, animation: "pulse 2.2s ease-out 1.8s infinite" }} />
                                  <Box sx={{ width: 11, height: 11, borderRadius: "50%", background: "#3567D6", border: "2.5px solid #fff", boxShadow: "0 2px 8px rgba(53,103,214,0.4)", position: "relative" }} />
                                </Box>
                              </Box>
                              <Typography sx={{ fontSize: "9px", color: "#3567D6", fontWeight: 700, minWidth: 32, textAlign: "right" }}>{timePct ?? 0}%</Typography>
                            </Stack>
                            <Stack direction="row" alignItems="center" gap={1}>
                              <Typography sx={{ fontSize: "9px", color: "#9DA3AE", fontWeight: 600, minWidth: 66, textTransform: "uppercase", letterSpacing: "0.4px" }}>Reports</Typography>
                              <Box sx={{ flex: 1, height: 9, borderRadius: "999px", background: "rgba(0,0,0,0.06)", position: "relative" }}>
                                <Box sx={{ position: "absolute", top: 0, left: 0, height: "100%", width: "0%", background: usagePct >= 85 ? "linear-gradient(90deg, #EF4444 0%, #F87171 100%)" : usagePct >= 60 ? "linear-gradient(90deg, #d97706 0%, #fbbf24 100%)" : "linear-gradient(90deg, #16a34a 0%, #4ade80 100%)", borderRadius: "999px", [`@keyframes uF_${fillAnimKey}`]: { "0%": { width: "0%" }, "100%": { width: `${usagePct ?? 0}%` } }, animation: `uF_${fillAnimKey} 2s ease-out 0.3s forwards` }} />
                              </Box>
                              <Typography sx={{ fontSize: "9px", color: usageBarColor, fontWeight: 700, minWidth: 32, textAlign: "right" }}>{usagePct ?? 0}%</Typography>
                            </Stack>
                            {loginData?.planName && (
                              <Stack direction="row" gap={1.5} mt={1.25}>
                                <Typography sx={{ fontSize: "9px", color: "#94a3b8", fontWeight: 600 }}>Plan: <span style={{ color: "#475569", fontWeight: 700 }}>{modifySubscriptionData() || loginData.planName}</span></Typography>
                              </Stack>
                            )}
                          </Box>
                          <Box sx={{ flexShrink: 0, textAlign: "center", minWidth: 68, background: "#fff", borderRadius: "12px", p: "8px 12px", boxShadow: "0 2px 10px rgba(53,103,214,0.09)" }}>
                            <Typography sx={{ fontSize: "22px", fontWeight: 800, color: daysColor, lineHeight: 1 }}>{remainingDays !== null ? remainingDays : "—"}</Typography>
                            <Typography sx={{ fontSize: "9px", color: "#9DA3AE", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.4px", mt: 0.35 }}>days left</Typography>
                          </Box>
                        </Stack>
                      </Box>
                    </Box>
                  );
                })()}
              </Stack>
            </Stack>
          )}
        </Box>
      )}

      <Stack
        flexGrow={2}
        p={3}
        sx={{
          borderRadius: "16px",
          backgroundColor: "#3567d6",
          color: "#ffffff",
          display: "none",
        }}
      >
        <Typography variant="h4">Offerings in Plan</Typography>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mt={4}
        >
          <Box pl={2}>
            <Typography
              mb={2}
              sx={{ fontSize: "26px", textTransform: "uppercase" }}
            >
              {loginData && loginData.role !== "admin"
                ? modifySubscriptionData()
                : ""}
            </Typography>
            {loginData && loginData.role !== "admin" ? (
              <Stack direction="column" gap={2}>
                <Typography variant="h6">
                  Start Date:{" "}
                  {loginData
                    ? loginData.startDate
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("-")
                    : ""}
                </Typography>
                <Typography variant="h6">
                  End Date:{" "}
                  {loginData
                    ? loginData.endDate
                        .split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("-")
                    : ""}
                </Typography>
              </Stack>
            ) : (
              <Typography variant="h6">Admin</Typography>
            )}
          </Box>
          {/* <img
            alt="doctor"
            src="https://dn96iqv3kf32j.cloudfront.net/new-company-website-files/engage-patients-section/1-engagePatientsImage.svg"
            width="200px"
          /> */}
        </Stack>
      </Stack>
      <Stack flexGrow={3}>
        <PlanDetailsSection
          reportsConsumed={numberOfReportsConsumed}
          dashboardInfo={dashboardInfo}
          productType={productType}
          loader={loader}
        />
      </Stack>

      {/* Repeat Rate — All clients (Smart Report) */}
      {loginData && productType === "smartreport" && (
        <Box
          sx={{
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 16px rgba(53,103,214,0.08)",
            overflow: "hidden",
            mb: 3
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ p: "18px 20px 12px" }}>
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: "15px", color: "#170C6B", mb: 0.3 }}>
                Patient Repeat Rate
              </Typography>
              <Typography sx={{ fontSize: "11.5px", color: "#9DA3AE" }}>
                How often patients return for a new report
              </Typography>
            </Box>
            
            {/* Top right date range */}
            {repeatRateStartDate && (() => {
               const fmt = (d) => {
                 const date = new Date(d);
                 if(isNaN(date.getTime())) return "N/A";
                 const parts = date.toDateString().split(" ");
                 return `${parts[2]} ${parts[1]}`;
               };
               const startStr = fmt(repeatRateStartDate);
               const current = new Date();
               const endStr = `${current.getDate().toString().padStart(2, '0')} ${['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][current.getMonth()]}`;
               const startYear = new Date(repeatRateStartDate).getFullYear();
               const endYear = current.getFullYear();

               return (
                  <Stack direction="row" alignItems="center" gap={0.8} sx={{
                    background: "#F0F4FF",
                    border: "1px solid #D0DEFF",
                    borderRadius: "10px",
                    px: 1.25,
                    py: 0.55,
                    flexShrink: 0,
                    ml: 1,
                  }}>
                    <Box sx={{ width: 22, height: 22, borderRadius: "5px", background: "#E0E8FF", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <CalendarMonthOutlinedIcon sx={{ fontSize: 13, color: "#3567D6" }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: "8.5px", fontWeight: 700, color: "#3567D6", textTransform: "uppercase", letterSpacing: "0.05em", lineHeight: 1.2 }}>
                        Source Date Range
                      </Typography>
                      <Typography sx={{ fontSize: "11px", fontWeight: 700, color: "#1e293b", lineHeight: 1.2, mt: 0.2 }}>
                        {startStr} {startYear} – {endStr} {endYear}
                      </Typography>
                    </Box>
                  </Stack>
               );
            })()}
          </Stack>
          <Box sx={{ borderTop: "1px solid #f0f4ff", overflow: "hidden" }}>
            <SmartReportRepeatRate loginData={loginData} navBarTriggered={navBarTriggered} onDateRangeChange={(date) => setRepeatRateStartDate(date)} />
          </Box>
        </Box>
      )}

      {/* Report Type Distribution — standalone card */}
      {loginData && loginData.role !== "admin" && (
        <Box
          sx={{
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 16px rgba(53,103,214,0.08)",
            overflow: "hidden",
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ p: "18px 20px 4px" }}>
            {/* Left: title + subtitle */}
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: "15px", color: "#170C6B", mb: 0.3 }}>
                Report Type Distribution
              </Typography>
              <Typography sx={{ fontSize: "11.5px", color: "#9DA3AE", mb: 1 }}>
                Breakdown of report types generated this period
              </Typography>
            </Box>

            {/* Right: Total Reports chip */}
            {reportTypeStats.total !== null && (
              <Stack direction="row" alignItems="center" gap={0.8} sx={{
                background: "#FFF7ED",
                border: "1px solid #fde8c8",
                borderRadius: "10px",
                px: 1.25,
                py: 0.55,
                flexShrink: 0,
                ml: 1,
              }}>
                <Box sx={{ width: 22, height: 22, borderRadius: "5px", background: "#F8DEBD", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke="#BA8139" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "8.5px", fontWeight: 700, color: "#92700a", textTransform: "uppercase", letterSpacing: "0.05em", lineHeight: 1.2 }}>
                    Total Reports
                  </Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 800, color: "#1e293b", lineHeight: 1.2 }}>
                    {reportTypeStats.total.toLocaleString("en-IN")}
                  </Typography>
                  {reportTypeStats.startDate && reportTypeStats.endDate && (() => {
                    const fmt = (d) => {
                      const [y, m, day] = d.split('-');
                      const mon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][parseInt(m,10)-1];
                      return `${day} ${mon}`;
                    };
                    const yr = `'${reportTypeStats.endDate.slice(2,4)}`;
                    return (
                      <Typography sx={{ fontSize: "8px", color: "#b45309", lineHeight: 1.2, mt: 0.1 }}>
                        {fmt(reportTypeStats.startDate)} – {fmt(reportTypeStats.endDate)} {yr}
                      </Typography>
                    );
                  })()}
                </Box>
              </Stack>
            )}
          </Stack>
          <ReportTypeSplitChart onStatsChange={(stats) => setReportTypeStats(stats)} />
        </Box>
      )}


      {/* ── Auto-scrolling Advertisement Carousel ── */}
      {loginData && loginData.role !== "admin" && (
        <Box sx={{ mb: 2.5 }}>
          <DashboardCarousel loginData={loginData} />
        </Box>
      )}


      {/* Smart Report Add-ons Table — standalone card */}
      {loginData && productType === "smartreport" && (
        <Box
          sx={{
            background: "#fff",
            borderRadius: "16px",
            boxShadow: "0 2px 16px rgba(53,103,214,0.08)",
            overflow: "hidden",
          }}
        >
          <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ p: "18px 20px 4px" }}>
            {/* Left: title + subtitle */}
            <Box>
              <Typography sx={{ fontWeight: 800, fontSize: "15px", color: "#170C6B", mb: 0.3 }}>
                Smart Report Add-ons
              </Typography>
              <Typography sx={{ fontSize: "11.5px", color: "#9DA3AE", mb: 1 }}>
                Add on usage breakdown for the selected period
              </Typography>
            </Box>

            {/* Right: Total Reports chip */}
            {addonsStats.total !== null && (
              <Stack direction="row" alignItems="center" gap={0.8} sx={{
                background: "#FFF7ED",
                border: "1px solid #fde8c8",
                borderRadius: "10px",
                px: 1.25,
                py: 0.55,
                flexShrink: 0,
                ml: 1,
              }}>
                <Box sx={{ width: 22, height: 22, borderRadius: "5px", background: "#F8DEBD", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" stroke="#BA8139" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </Box>
                <Box>
                  <Typography sx={{ fontSize: "8.5px", fontWeight: 700, color: "#92700a", textTransform: "uppercase", letterSpacing: "0.05em", lineHeight: 1.2 }}>
                    Total Reports
                  </Typography>
                  <Typography sx={{ fontSize: "13px", fontWeight: 800, color: "#1e293b", lineHeight: 1.2 }}>
                    {addonsStats.total.toLocaleString("en-IN")}
                  </Typography>
                  {addonsStats.startDate && addonsStats.endDate && (() => {
                    const fmt = (d) => {
                      const [y, m, day] = d.split('-');
                      const mon = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][parseInt(m,10)-1];
                      return `${day} ${mon}`;
                    };
                    const yr = `'${addonsStats.endDate.slice(2,4)}`;
                    return (
                      <Typography sx={{ fontSize: "8px", color: "#b45309", lineHeight: 1.2, mt: 0.1 }}>
                        {fmt(addonsStats.startDate)} – {fmt(addonsStats.endDate)} {yr}
                      </Typography>
                    );
                  })()}
                </Box>
              </Stack>
            )}
          </Stack>
          <SmartReportAddonsTable onStatsChange={(stats) => setAddonsStats(stats)} />
        </Box>
      )}
    </Stack>
  );
};

export default WelcomeScreenAndPlanSection;
